const CreateShippingObject = (
	country = 'NZ',
	orderType,
	email,
	submittedShippingData
) => {
	const {
		salutation = '',
		addressType = '',
		firstName,
		lastName,
		deliveryInstructions = '',
		deliveryInstructionsOtherInput = '',
		companyName = '',
		address1,
		address2 = '',
		postalCode,
		city,
		dayPhoneNumber,
		phoneNumber,
		stateCode,
	} = submittedShippingData;

	let finalAddressType = addressType
		? addressType
		: companyName.length > 0
		? 'Commercial'
		: 'Residential';

	let deliveryInstructionTxtLine1 = '',
		deliveryInstructionTxtLine2 = '',
		deliveryInstructionTxtLine3 = '',
		deliveryInstructionTxtLine4 = '';
	if (deliveryInstructions && deliveryInstructionsOtherInput) {
		let deliveryInstructionsArray =
			deliveryInstructionsOtherInput.match(/.{1,24}/g);
		[
			deliveryInstructionTxtLine1 = '',
			deliveryInstructionTxtLine2 = '',
			deliveryInstructionTxtLine3 = '',
			deliveryInstructionTxtLine4 = '',
		] = deliveryInstructionsArray;
	}

	let shippingDetail = {
		type: orderType,
		shippingAddress: {
			address: {
				type: country,
				postalCode,
				address1,
				address2,
				city,
				country,
				addressType: finalAddressType,
				deliveryInstructions: {
					deliveryInstruction: deliveryInstructions,
					deliveryInstructionTxtLine1,
					deliveryInstructionTxtLine2,
					deliveryInstructionTxtLine3,
					deliveryInstructionTxtLine4,
				},
			},
			contactInfo: {
				email,
				companyName,
				deliveryPhoneNumber: dayPhoneNumber || phoneNumber,
				dayPhoneNumber: dayPhoneNumber || phoneNumber,
			},
			personalInfo: {
				salutation,
				firstName,
				lastName,
			},
		},
	};

	if (country === 'AU') {
		shippingDetail = {
			...shippingDetail,
			shippingAddress: {
				...shippingDetail.shippingAddress,
				address: {
					...shippingDetail.shippingAddress.address,
					state: stateCode,
					stateCode,
				},
			},
		};
	}

	return {
		shippingDetail,
	};
};

export default CreateShippingObject;
